import { createSelector } from 'reselect';

export const getOrderedUserBoundaries = createSelector(
  (state) => state.user.get('boundaries'),
  (userBoundaries) => userBoundaries.sort((a, b) => a.get('name').localeCompare(b.get('name'))),
);

export const getUserId = (state) => state.user.getIn(['user', 'uid']);

export const getUserEmail = (state) => state.user.getIn(['user', 'email']);
